import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import type { FunctionComponent } from 'react';
import { useContext } from 'react';
import { Link as RouterLink } from 'react-router';

import { ApplicationContext } from '~/shared/context/context';
import type { TranslationKey } from '~/shared/internationalization/translation';

import { Text } from '../../../../design/components/Typography';

export type NavigationItemProperties = {
    readonly pathname?: string;
    readonly text: TranslationKey;
    readonly urlHash?: string;
};

export const NavigationItem: FunctionComponent<NavigationItemProperties> = (properties) => {
    const { translate } = useContext(ApplicationContext);
    const { pathname, text, urlHash } = properties;

    return (
        <ListItem key={text} disablePadding={true}>
            <ListItemButton component={RouterLink} sx={{ py: 1.5 }} to={{ hash: urlHash, pathname }}>
                <Text color="secondary">{translate(text)}</Text>
            </ListItemButton>
        </ListItem>
    );
};
